module.exports = __webpack_public_path__ + "static/media/HelveticaNowText-Regular.c9442de9.woff";